export default "__VITE_ASSET__9ab9e59d__"